import React, { useCallback, useEffect } from "react";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import SearchIcon from "@material-ui/icons/Search";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import InputBase from "@material-ui/core/InputBase";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import Tooltip from "@material-ui/core/Tooltip";
import ClearIcon from "@material-ui/icons/Clear";
import { ListItemSecondaryAction, IconButton } from "@material-ui/core";
import Axios from "axios";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { templateHelper } from "../../../cms/areas/template/helpers/templateHelper";
import { connect } from "react-redux";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { OnlineBadge } from "../../components/shared/OnlineBadge";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../../helpers/objectHelper";
import UserDetailsEditDialog from "./components/UserDetailsEditDialog";

function UserCardModule(props) {
  const {
    clientName,
    companyName,
    settings,
    template,
    preview = false,
    profileImage,
    eventId,
    lang,
    orderId
  } = props;
  useEffect(() => {
    init(eventId, "DigitalMeeting.UserCard", lang);
  }, []);
  const getStyle = () => {
    const obj = template.interaction.userCard;

    if (obj) {
      const frame = obj.frame;
      const avatar = obj.avatar;
      const name = obj.name;
      const company = obj.company;
      return {
        frame: {
          background: frame.background != "unset" ? frame.background : "#fff",
          borderColor:
            frame.borderColor != "unset" ? frame.borderColor : "unset",
          borderWidth: frame.borderWidth != "unset" ? frame.borderWidth : "0px",
          borderRadius:
            frame.borderRadius != "unset" ? frame.borderRadius : "0px",
          boxShadow: "none",
          borderStyle: "solid",
        },
        avatar: {
          background: avatar.background != "unset" ? avatar.background : "#red",
          color: avatar.color != "unset" ? avatar.color : "#fff",
          borderRadius:
            avatar.borderRadius != "unset" ? avatar.borderRadius : "50%",
        },

        name: {
          fontSize: name.fontSize != "unset" ? name.fontSize : "15px",
          color: name.color != "unset" ? name.color : "#222",
          fontWeight: name.fontWeight != "unset" ? name.fontWeight : "normal",
          fontFamily:
            name.fontFamily != "unset" ? name.fontFamily : "Open Sans",
        },
        company: {
          fontSize: company.fontSize != "unset" ? company.fontSize : "15px",
          color: company.color != "unset" ? company.color : "#222",
          fontWeight:
            company.fontWeight != "unset" ? company.fontWeight : "normal",
          fontFamily:
            company.fontFamily != "unset" ? company.fontFamily : "Open Sans",
        },
      };
    } else {
    }
  };
  const setStyle = useCallback(() => getStyle(), [template]);
  const style = setStyle();
  const { allowProfileEdit } = settings;

  return (
    <Card
      className="user-card"
      style={{
        ...style.frame,
        padding: "10px 0px",
        height: "auto",
        margin: "auto",
        height: "100%",
        width: "100%",
        position: "relative",
      }}
    >
      <ListItem
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          height: "100%",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ListItemAvatar>
          <OnlineBadge
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            overlap="circular"
            variant="dot"
          >
            <Avatar src={profileImage} style={{ ...style.avatar }}>
              <PersonRoundedIcon />
            </Avatar>
          </OnlineBadge>
        </ListItemAvatar>
        <ListItemText
          primary={
            <span style={{ ...style.name }}>
              {preview ? 'Bruce Wayne' : (clientName || (
                <EventLabel2 name="Guest" groupName="DigitalMeeting.UserCard" />
              ))}
            </span>
          }
          secondary={
            <span style={{ ...style.company }}>{preview ? 'Waynes Enterprise' : (companyName || "")}</span>
          }
        />
        {allowProfileEdit && orderId ? (
          <ListItemSecondaryAction>
            <UserDetailsEditDialog {...combineProps([props, style])} />
          </ListItemSecondaryAction>
        ) : null}
      </ListItem>
    </Card>
  );
}

function mapStateToProps(state) {
  return {
    template: state.template.template
      ? state.template.template.content
      : undefined,
  };
}
export default connect(mapStateToProps)(UserCardModule);
